/* eslint-disable */
import { useQualityAnalysisStore } from '../../QualityAnalysisStore';
import { useShallow } from 'zustand/react/shallow';

const MainTabs = () => {
    const { tabs, activeTab, setActiveTab } = useQualityAnalysisStore(
        useShallow(state => ({
            tabs: state.tabs,
            activeTab: state.activeTab,
            setActiveTab: state.setActiveTab
        }))
    );

    return (
        <div className="bg-gray-100 mb-2 w-full">
            <div className="flex">
                {tabs.map(tab => (
                    <div
                        key={tab.key}
                        className={`p-3 cursor-pointer flex items-center justify-center ${
                            activeTab === tab.key 
                            ? 'bg-white border-t border-l border-r rounded-t-lg min-w-[200px] text-center text-black font-bold' 
                            : tab.disabled 
                                ? 'text-slate-400 font-bold min-w-[200px] text-center pointer-events-none'
                                : 'text-slate-600 font-bold min-w-[200px] text-center'
                        }`}
                        onClick={() => !tab.disabled && setActiveTab(tab.key)}
                    >
                        {tab.disabled ? (
                            <div className='flex items-center'>
                                {tab.label} <span className='bg-slate-400 rounded-full px-2 py-1 ml-2 text-xs font-bold text-slate-600'>Coming Soon</span>
                            </div>
                        ) : tab.label}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MainTabs; 